import { render, staticRenderFns } from "./LockSpeedDial.vue?vue&type=template&id=1c97b767&scoped=true"
import script from "./LockSpeedDial.vue?vue&type=script&lang=js"
export * from "./LockSpeedDial.vue?vue&type=script&lang=js"
import style0 from "./LockSpeedDial.vue?vue&type=style&index=0&id=1c97b767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c97b767",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VSpeedDial})
